/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /**
   * Press Reviews Carousel Component
   * Converts grid layout to carousel using Flickity when blocks exceed blocks_per_row
   */
  if (!customElements.get('press-reviews-carousel')) {
    customElements.define(
      'press-reviews-carousel',
      class PressReviewsCarousel extends HTMLElement {
        constructor() {
          super();
          this.reviewsContainer = null;
          this.blocksPerRowLarge = parseFloat(this.dataset.blocksPerRowLarge || 2.5);
          this.blocksPerRowMedium = parseFloat(this.dataset.blocksPerRowMedium || 2.2);
          this.blocksPerRowSmall = parseFloat(this.dataset.blocksPerRowSmall || 1.2);
          this.totalBlocks = parseInt(this.dataset.totalBlocks || 0, 10);
          this.flkty = null;
          this.isMobile = false;
          this.handleResize = this.handleResize.bind(this);
        }

        connectedCallback() {
          this.init();
          document.addEventListener('theme:resize:width', this.handleResize);
        }

        handleResize() {
          this.init();
        }

        getBlocksPerRow() {
          // Responsive breakpoints matching CSS
          const screenWidth = window.innerWidth;
          
          if (screenWidth >= 1200) {
            return this.blocksPerRowLarge;
          } else if (screenWidth >= 500) {
            return this.blocksPerRowMedium;
          } else {
            return this.blocksPerRowSmall;
          }
        }

        init() {
          this.reviewsContainer = this.querySelector('.section-press-reviews__reviews');
          
          if (!this.reviewsContainer) return;

          const currentBlocksPerRow = this.getBlocksPerRow();
          
          // Update CSS variable for responsive grid
          // this.style.setProperty('--blocks-per-row', currentBlocksPerRow);

          // Check if we need carousel mode
          const shouldBeCarousel = this.totalBlocks > currentBlocksPerRow;

          if (shouldBeCarousel) {
            this.enableCarousel();
          } else {
            this.disableCarousel();
          }
        }

        enableCarousel() {
          this.reviewsContainer.classList.add('is-carousel');
          
          // Initialize Flickity if not already initialized
          if (!this.flkty) {
            this.initializeFlickity();
          }
        }

        disableCarousel() {
          this.reviewsContainer.classList.remove('is-carousel');
          
          // Destroy Flickity if it exists
          if (this.flkty) {
            this.flkty.destroy();
            this.flkty = null;
            this.reviewsContainer.classList.remove('flickity-enabled');
          }
        }

        initializeFlickity() {
          const options = {
            cellAlign: 'left',
            contain: true,
            draggable: true,
            freeScroll: false,
            friction: 0.3,
            initialIndex: 0,
            pageDots: true,
            prevNextButtons: true,
            wrapAround: false,
          };

          // Use theme's Flickity class if available, otherwise use window.Flickity
          if (window.theme && window.theme.Flickity) {
            this.flkty = new window.theme.Flickity(this.reviewsContainer, options);
          } else if (window.Flickity) {
            this.flkty = new window.Flickity(this.reviewsContainer, options);
          } else {
            console.error('Flickity library is not loaded.');
          }
        }

        disconnectedCallback() {
          document.removeEventListener('theme:resize:width', this.handleResize);
          if (this.flkty) {
            this.flkty.destroy();
            this.flkty = null;
          }
        }
      }
    );
  }

  if (!customElements.get('swatch-list')) {
    customElements.define(
      'swatch-list',
      class SwatchList extends HTMLElement {
        connectedCallback() {
          this.swatchItems = this.querySelector('.swatch-list__items');
          this.loadingMessage = this.querySelector('.swatch-list__loading-message');

          this.initSwatchList();
        }

        initSwatchList() {
          this.classList.add('swatch-list--expandable', 'swatch-list--collapsed');

          this.addButton();
        }

        addButton() {
          const button = document.createElement('button');
          button.type = 'button';
          button.classList.add('swatch-list-button', 'btn', 'hidden');
          button.textContent = theme.swatchList.showAllColors;

          this.appendChild(button);

          button.addEventListener('click', this.expandSwatchList.bind(this));
          this.button = button;

          this.removeLoadingState();
        }

        expandSwatchList(event) {
          event.preventDefault();

          const button = event.target;

          this.classList.remove('swatch-list--collapsed');
          button.remove();
        }

        removeLoadingState() {
          this.button ??= this.querySelector('.swatch-list-button');
          this.swatchItems ??= this.querySelector('.swatch-list__items');
          this.loadingMessage ??= this.querySelector('.swatch-list__loading-message');

          this.loadingMessage.remove();

          this.button.classList.remove('hidden');
          this.swatchItems.classList.remove('hidden');
        }
      }
    );
  }

  if (!customElements.get('delivery-estimate')) {
    customElements.define(
      'delivery-estimate',
      class DeliveryEstimate extends HTMLElement {
        connectedCallback() {
          this.init();
        }
        init() {
          tippy(this.button, {
            trigger: 'click',
            interactive: true,
            content: this.tooltip,
            // allowHTML: true,
            theme: "kyte--light",
            // theme: "kyte--dark",
            placement: "bottom"
          });
        }
        get button() {
          return this.querySelector(".delivery-estimate__button");
        }
        get tooltip() {
          return this.querySelector(".delivery-estimate__tooltip");
        }
      }
    );
  }

  if (!customElements.get('product-inventory')) {
    customElements.define(
      'product-inventory',
      class ProductInventory extends HTMLElement {
        connectedCallback() {
          this.threshold = parseInt(this.dataset.threshold);
          this.inStockColor = this.dataset.inStockColor;
          this.lowStockColor = this.dataset.lowStockColor;
          this.outOfStockColor = this.dataset.outOfStockColor;
          this.showNotice = this.dataset.showNotice;
          this.showInventoryCounter = this.dataset.showInventoryCounter === 'true';
          document.getElementById(this.getAttribute("form-id"))?.addEventListener("theme:variant:change", this._onVariantChanged.bind(this));
        }
        _onVariantChanged(event) {
          const variant = event.detail.variant;

          if (!variant) {
            return;
          }

          let status = '';
          let html = '';

          const inventory = variant.inventory_quantity;
          const policy = variant.inventory_policy;
          
          if (variant.inventory_management && policy === 'deny') {
            if (inventory > 0 && inventory <= this.threshold) {
              status = 'low-stock'
            } else if (inventory > 0 && inventory > this.threshold && this.showNotice === 'always') {
              status = 'in-stock'
            } else if (inventory < 1 && this.showNotice === 'always') {
              status = 'out-of-stock';
            } 
          } else if (policy === 'continue') {
            status = 'in-stock';
          }

          if (status === 'in-stock') {
            // in-stock
            html = `
              <span class="variant__inventory variant__inventory--high" style="--icon-color: ${this.inStockColor}">
                <span class="variant__countdown-text">${theme.productInventory.inStock}</span>
              </span>
            `;
          } else if (status === 'low-stock') {
            // low-stock
            if (this.showInventoryCounter) {
              html = `
                <span class="variant__inventory variant__inventory--low" style="--icon-color: ${this.lowStockColor}">
                  <span class="variant__countdown-text">${theme.productInventory.remaining.replace('{{ inventory }}', inventory)}</span>
                </span>
              `;
            } else {
              html = `
                <span class="variant__inventory variant__inventory--low" style="--icon-color: ${this.lowStockColor}">
                  <span class="variant__countdown-text">${theme.productInventory.remainingNoCount}</span>
                </span>
              `;
            }
          } else if (status === 'out-of-stock') {
            // out-of-stock
            html = `
              <span class="variant__inventory variant__inventory--out" style="--icon-color: ${this.outOfStockColor}">
                <span class="variant__countdown-text">${theme.productInventory.outOfStock}</span>
              </span>
            `;
          }

          this.replaceChildren();
          this.insertAdjacentHTML('afterbegin', html);
        }
      }
    );
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
